import { render, staticRenderFns } from "./SettingsReportValues.vue?vue&type=template&id=7820303e"
import script from "./SettingsReportValues.ts?vue&type=script&lang=ts&external"
export * from "./SettingsReportValues.ts?vue&type=script&lang=ts&external"
import style0 from "./SettingsReportValues.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports